export const PAYMENT_STATUS_SUCCESS = "success"
export const PAYMENT_STATUS_PREPAID = "prepaid"
export const PAYMENT_STATUS_ONSITE = "onsite"
export const PAYMENT_STATUS_FAILED = "failed"
export const PAYMENT_STATUS_PENDING = "pending"
export const PAYMENT_STATUS_NEEDS_PAYMENT = "needs-payment"
